export default __webpack_public_path__ + "static/media/Helvetica-Italic.ec5a918d.ttf";